/* eslint react/jsx-filename-extension:0 */
import React from 'react'
import { types } from 'mobx-state-tree'
import { toast } from 'react-toastify'

export const ToastStore = types
  .model('ToastStore', {
    shownIds: types.array(types.string)
  })
  .actions(self => ({
    addToast({ message, Component, options, type }) {
      const toastType = toast.TYPE[type]
      const defaultOptions = {
        type: type ? toastType : toast.TYPE.DEFAULT
      }
      let id
      const toastOptions = {
        ...defaultOptions,
        ...options
      }
      if (Component) {
        id = toast(<Component message={message} />, toastOptions)
      } else {
        id = toast(message, toastOptions)
      }
      self.shownIds.push(id)
      return id
    },
    updateToast(id, options) {
      if (toast.isActive(id)) {
        toast.update(id, options)
      }
    },
    closeToast(id) {
      if (toast.isActive(id)) {
        toast.dismiss(id)
      }
      toast.self.shownIds = self.shownIds.filter(shownId => shownId !== id)
    }
  }))
